export default __webpack_public_path__ + "static/media/logoImpactoolsMedicao.af6bb0d3.svg";